import { coerceNumber } from '@partners/utils';
import { FormField } from '../form.field';
import { IFormField } from '../form.interface';

export class NumericField<T = number> extends FormField<T> {
  constructor(args?: IFormField<T>) {
    super({
      ...args,
      ...{
        bidi: true,
        inputType: 'tel',
        inputMode: 'numeric',
        beforeChange: ({ nextValue, prevValue }) => {
          return {
            nextValue: coerceNumber(nextValue) as T,
            prevValue: coerceNumber(prevValue) as T
          };
        }
      }
    });

    // this.control.valueChanges.pipe(
    //   map((value) => coerceNumber(value)),
    //   tap((value) => console.log(`>>>>>>>>>>>> ${value}`))
    // );
  }
}
